export default __webpack_public_path__ + "static/media/import_stock_levels.272be42f.png";